var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInternationalicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_20_30440)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 82,
    height: 82,
    rx: 41,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 81,
    height: 81,
    rx: 40.5,
    stroke: "#EAECF0",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6665 45.0834C59.4498 45.0834 59.2332 45.0334 59.0332 44.9001L54.8665 42.4001C52.6998 41.1001 49.9998 41.1001 47.8165 42.4001C44.8498 44.1834 41.1665 44.1834 38.1998 42.4001C36.0331 41.1001 33.3332 41.1001 31.1498 42.4001L26.9832 44.9001C26.3832 45.2501 25.6165 45.0668 25.2665 44.4668C24.9165 43.8668 25.0998 43.1001 25.6998 42.7501L29.8665 40.2501C32.8331 38.4668 36.5165 38.4668 39.4832 40.2501C41.6498 41.5501 44.3498 41.5501 46.5331 40.2501C49.4998 38.4668 53.1832 38.4668 56.1499 40.2501L60.3165 42.7501C60.9165 43.1001 61.0998 43.8668 60.7498 44.4668C60.4998 44.8668 60.0832 45.0834 59.6665 45.0834Z",
    fill: "url(#paint0_linear_20_30440)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.667 33.4168C33.0004 33.4168 31.3337 32.9668 29.8503 32.0835L25.6837 29.5835C25.0837 29.2335 24.9004 28.4668 25.2504 27.8668C25.6004 27.2835 26.367 27.0835 26.967 27.4335L31.1337 29.9335C33.3004 31.2335 36.0003 31.2335 38.1837 29.9335C41.1503 28.1501 44.8337 28.1501 47.8004 29.9335C49.967 31.2335 52.667 31.2335 54.8503 29.9335L59.017 27.4335C59.617 27.0835 60.3837 27.2668 60.7337 27.8668C61.0837 28.4501 60.9004 29.2335 60.3004 29.5835L56.1337 32.0835C53.167 33.8668 49.4837 33.8668 46.517 32.0835C44.3503 30.7835 41.6504 30.7835 39.467 32.0835C38.0004 32.9668 36.3337 33.4168 34.667 33.4168Z",
    fill: "url(#paint1_linear_20_30440)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6665 56.7499C59.4498 56.7499 59.2332 56.6999 59.0332 56.5666L54.8665 54.0666C52.6998 52.7666 49.9998 52.7666 47.8165 54.0666C44.8498 55.8499 41.1665 55.8499 38.1998 54.0666C36.0331 52.7666 33.3332 52.7666 31.1498 54.0666L26.9832 56.5666C26.3832 56.9166 25.6165 56.7333 25.2665 56.1333C24.9165 55.5333 25.0998 54.7666 25.6998 54.4166L29.8665 51.9166C32.8331 50.1333 36.5165 50.1333 39.4832 51.9166C41.6498 53.2166 44.3498 53.2166 46.5331 51.9166C49.4998 50.1333 53.1832 50.1333 56.1499 51.9166L60.3165 54.4166C60.9165 54.7666 61.0998 55.5333 60.7498 56.1333C60.4998 56.5333 60.0832 56.7499 59.6665 56.7499Z",
    fill: "url(#paint2_linear_20_30440)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_20_30440",
    x: 0,
    y: 0,
    width: 86,
    height: 86,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_20_30440"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_20_30440",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20_30440",
    x1: 43.0081,
    y1: 38.9126,
    x2: 43.0081,
    y2: 45.0834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD5004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE1C2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_20_30440",
    x1: 42.992,
    y1: 27.2568,
    x2: 42.992,
    y2: 33.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD5004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE1C2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_20_30440",
    x1: 43.0081,
    y1: 50.5791,
    x2: 43.0081,
    y2: 56.7499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD5004"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE1C2D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternationalicon);
export default __webpack_public_path__ + "static/media/internationalicon.fd69ea429d7eecad58e8b6333dd098dc.svg";
export { ForwardRef as ReactComponent };